var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "projectChart" },
    [
      _c("echart", {
        ref: "radchart",
        attrs: { chartID: "radchart", chartHeight: _vm.height }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }